module.exports = __webpack_public_path__ + "assets/img/img_illustrations@2x.8fb78631.png";